<template>
  <div>
    <b-row>
      <b-col>
        <find-or-create-contact-form
          ref="findOrCreateContactForm"
          search-label="Full name"
          v-model="contactId"
          :accountId="account.id"
        ></find-or-create-contact-form>
      </b-col>

      <b-col>
        <base-input label="Appointment Date" name="Appointment Date">
          <flat-pickr
            slot-scope="{ focus, blur }"
            @on-open="focus"
            @on-close="blur"
            :config="startDateConfig"
            class="form-control datepicker"
            v-model="startDate"
          ></flat-pickr>
        </base-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" v-if="showAdditionalAppointmentOptions" class="text-right">
        <span class="text-muted mr-4 small">Also appointed as:</span>

        <b-form-checkbox
          class="custom-control-inline"
          id="additional-appointment-director"
          v-model="additionalAppointmentTypes.director"
          name="additional-appointment-director"
          v-if="type !== 'director'"
        >
          Director
        </b-form-checkbox>

        <b-form-checkbox
          class="custom-control-inline"
          id="additional-appointment-secretary"
          v-model="additionalAppointmentTypes.secretary"
          name="additional-appointment-secretary"
          v-if="type !== 'secretary'"
        >
          Secretary
        </b-form-checkbox>

        <b-form-checkbox
          class="custom-control-inline"
          id="additional-appointment-beneficial-ownership-officer"
          v-model="additionalAppointmentTypes.beneficial_ownership_officer"
          name="additional-appointment-beneficial-ownership-officer"
          v-if="type !== 'beneficial_ownership_officer'"
        >
          Beneficial Ownership Officer
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col sm="3">
        <b-btn
          v-if="!showAdditionalAppointmentOptions"
          variant="link"
          @click="showAdditionalAppointmentOptions = true"
          ><i class="fas fa-plus mr-2"></i>More roles</b-btn
        >
      </b-col>

      <b-col sm="9" class="text-right" variant="default">
        <b-btn @click="$emit('cancel')">
          <i class="fa fa-times mr-2"></i> Cancel
        </b-btn>

        <b-btn @click="create" variant="success">
          <span v-if="!creating">
            Create {{ type | humanize }}
            <i class="fa fa-arrow-right ml-2"></i>
          </span>
          <span v-else>
            <i class="fa fa-spin fa-spinner mr-2"></i> Please wait&hellip;
          </span>
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import FindOrCreateContactForm from "../Contacts/FindOrCreateContactForm";
import { get } from "dot-prop";
import each from "async/each";

export default {
  name: "appointment-create-form",
  components: {
    FindOrCreateContactForm
  },
  props: {
    companyId: {
      type: String,
      description: "Company ID",
      required: true
    },
    existingAppointments: {
      type: Array,
      description: "Existing Appointments",
      required: false
    },
    companyIncorporationDate: {
      type: String,
      description: "Company Incorporation Date",
      required: false
    },
    type: {
      type: String,
      description: "Appointment type",
      required: true,
      validator: function(value) {
        // The value must match one of these strings
        return (
          ["director", "secretary", "beneficial_ownership_officer"].indexOf(
            value
          ) !== -1
        );
      }
    }
  },
  data() {
    return {
      contactId: null,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: null,
      creating: false,
      errorMessage: null,
      startDateConfig: {
        allowInput: true,
        defaultDate: moment().format("YYYY-MM-DD")
      },
      showAdditionalAppointmentOptions: false,
      additionalAppointmentTypes: {
        director: false,
        secretary: false,
        beneficial_ownership_officer: false
      }
    };
  },
  computed: {
    account: function() {
      return this.$store.state.account;
    }
  },
  created() {
    if (this.companyIncorporationDate) {
      this.startDateConfig.minDate = this.companyIncorporationDate;
    }

    if (this.existingAppointments !== null) {
      if (this.existingAppointments.length < 1) {
        this.startDate = this.companyIncorporationDate;
        this.startDateConfig.defaultDate = this.companyIncorporationDate;
      }
    }
    // TODO: if other appointments exist but all are resigned, set default date to latest resignation date
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        // focus on input
        this.$refs.findOrCreateContactForm.setFocus();
      });
    },
    create() {
      this.creating = true;

      const startDate = this.startDate;
      const contactId = this.contactId;

      const appointments = [this.type];
      if (this.additionalAppointmentTypes.director) {
        appointments.push("director");
      }
      if (this.additionalAppointmentTypes.secretary) {
        appointments.push("secretary");
      }
      if (this.additionalAppointmentTypes.beneficial_ownership_officer) {
        appointments.push("beneficial_ownership_officer");
      }

      each(
        appointments,
        (type, next) => {
          const requestBody = {
            contactId,
            startDate,
            type
          };

          this.axios
            .post(
              `/v1/accounts/${this.account.id}/companies/${this.companyId}/appointments`,
              requestBody
            )
            .then(response => {
              if (response.data) {
                const appointment = response.data;
                this.$emit("create-appointment", appointment);
              }

              return next();
            })
            .catch(next);
        },
        error => {
          this.creating = false;

          if (error) {
            this.errorMessage = "Failed to create appointment";
            if (get(error, "response.data.message")) {
              this.errorMessage = error.response.data.message;
            }
          } else {
            let msg;
            if (appointments.length > 1) {
              msg = `${appointments.length} appointments created`;
            } else {
              msg = "Appointment created";
            }

            this.$notify({
              message: msg,
              timeout: 3000,
              icon: "fa fa-check",
              type: "success"
            });
          }
        }
      );
    }
  }
};
</script>
